import { type IconProps } from '@phosphor-icons/react';
import { Button } from '@/components/ui/Button';
import { PlusIcon } from '@phosphor-icons/react';

export interface TableEmptyStateConfig {
    icon?: React.ComponentType<IconProps>;
    title: string;
    description?: string;
    buttonText?: string;
    buttonIcon?: React.ReactNode;
    onButtonClick?: () => void;
}

interface TableEmptyStateProps {
    config: TableEmptyStateConfig;
    columnCount: number;
}

export function TableEmptyState({ config, columnCount }: TableEmptyStateProps) {
    const {
        icon: IconComponent,
        title,
        description,
        buttonText,
        buttonIcon,
        onButtonClick,
    } = config;

    return (
        <tbody>
            <tr>
                <td colSpan={columnCount} className="p-0">
                    <div className="flex items-center justify-center min-h-[320px] py-12">
                        <div className="flex flex-col items-center gap-8 max-w-[346px]">
                            <div className="flex flex-col items-center gap-6">
                                {IconComponent && (
                                    <IconComponent
                                        className="size-10 text-grey-400"
                                        weight="regular"
                                    />
                                )}
                                <div className="flex flex-col items-center gap-2 text-center">
                                    <h3 className="text-lg font-medium text-grey-200">
                                        {title}
                                    </h3>
                                    {description && (
                                        <p className="text-sm text-grey-400">
                                            {description}
                                        </p>
                                    )}
                                </div>
                            </div>
                            {buttonText && onButtonClick && (
                                <Button
                                    variant="primary"
                                    onClick={onButtonClick}
                                    leadingIcon={
                                        buttonIcon ?? (
                                            <PlusIcon
                                                className="size-4"
                                                weight="regular"
                                            />
                                        )
                                    }
                                >
                                    {buttonText}
                                </Button>
                            )}
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    );
}
